import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Stack, Text } from '@chakra-ui/react'

import { JobsiteFilter } from 'InstitutionalManagement/types'
import JobsiteFilterForm from 'InstitutionalManagement/components/JobsiteFilterForm'
import { JOBSITE_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/jobsites'
import { useCustomFormJobsiteSelectionDrawerManager } from '../../contexts/CustomFormJobsiteSelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchJobsiteOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<JobsiteFilter>({ defaultValues: JOBSITE_INITIAL_FILTER })

  const { setView, filter, setFilter, setLoadingJobsites } = useCustomFormJobsiteSelectionDrawerManager()

  function onSubmit(jobsiteFilter: JobsiteFilter) {
    setFilter({ ...filter, ...jobsiteFilter })
    setLoadingJobsites(true)
    setView('SELECT_JOBSITE')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar um posto de trabalho</Text>
        <Heading color="primary">Pesquisar os postos de trabalho</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <JobsiteFilterForm register={register} />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar posto de trabalho</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchJobsiteOnCustomForm
